const ErrorPage  = () => {
  return ( <h1>ERROR! PAGE NOT FOUND</h1> );
}
 
export default ErrorPage;